import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Divider } from 'antd'
import { Wrapper } from 'modules/Roles/Partials/RolesFilter/Styles/style'

const JobTypeFilter = ({
  jobTypeLevel,
  setJobTypeLevel,
  jobType,
  setJobType,
}) => {
  const options1 = [
    {
      label: 'Entry level',
      value: 'ENTRY',
    },
    {
      label: 'Internship',
      value: 'INTERN',
    },
    {
      label: 'Experience Candidate',
      value: 'EXPERIENCED'
    }
  ]

  const options2 = [
    {
      label: 'Full time',
      value: 'FULL_TIME',
    },
    {
      label: 'Part time',
      value: 'PART_TIME ',
    },
  ]

  const jobTypeChange = (values, key) => {
    if (key == 'jobTypeLevel') {
      setJobTypeLevel([values[values?.length - 1]])
    }
    if (key == 'jobType') {
      setJobType([values[values?.length - 1]])
    }
  }

  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={jobTypeLevel}
        options={options1}
        onChange={value => jobTypeChange(value, 'jobTypeLevel')}
      />
      <Divider style={{ margin: '10px 0' }} />
      <FilterCheckBoxComp
        value={jobType}
        options={options2}
        onChange={value => jobTypeChange(value, 'jobType')}
      />
    </Wrapper>
  )
}

export default JobTypeFilter
